module.exports = __webpack_public_path__ + "files/b7921919221261eef6a34af96ee9e0ce.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/PT-Sans-regular.woff2
 ** module id = 867
 ** module chunks = 0
 **/